import React, { useEffect, useState } from "react";
import { ICourse, IModule, IQuestionAnswer, IQuiz, IUserCourse } from "utils/types";
import { CourseFullView, CourseFullViewProps } from "./CourseFullView";
import { CourseStudyIntro, CourseStudyIntroProps } from "./CourseStudyIntro";
import { s } from "framer-motion/dist/types.d-6pKw1mTI";
import { useSearchParams } from "react-router-dom";



export interface CourseOverviewProps extends Pick<CourseFullViewProps, 
  "onGetQuizQuestions"|"onGetQuizYears"
>{
  courseId: string;
  course?: ICourse;
  onGetCourse: (course: Partial<ICourse>) => Promise<ICourse|undefined>;
  onMoveToCourseStudy: CourseStudyIntroProps["onMoveToCourseStudy"];
  onGetCourseModules: (courseId: string) => Promise<IModule[]>;
  onBack: () => void;
  onGetUserCourse: (courseId: string) => Promise<IUserCourse|undefined>
}
export type IPage = "full-view" | "study-overview"
export const CourseOverview: React.FC<CourseOverviewProps> = ({
  courseId, course: initCourse, onGetCourse,
  onMoveToCourseStudy, onGetCourseModules, onBack, onGetUserCourse,
  onGetQuizQuestions, onGetQuizYears
}) => {
  const [searchParam] = useSearchParams();
  const tabPage = searchParam.get("page") as IPage
  const [course, setCourse] = useState<ICourse|undefined>(initCourse)
  const [modules, setModules] = useState<IModule[]>([])
  const [userCourse, setUserCourse] = useState<IUserCourse>()
  const [page, setPage] = useState<IPage>(tabPage || "full-view");

  useEffect(() => {
    if(courseId && !initCourse){
      onGetCourse({id: courseId}).then(setCourse)
    }
    if(courseId){
      onGetCourseModules(courseId).then(modules => {
        // sort modules by index 
        setModules([...modules].sort((a, b) => a?.index - b?.index))
      })
      onGetUserCourse(courseId).then(setUserCourse)
    }
  }, [courseId, JSON.stringify(initCourse)])

  return (
    <>
      {page === "full-view" && <CourseFullView  {...{
        course: course || initCourse, modules,
        onMoveToCourseStudy() {
          setPage("study-overview");
        },
        onGetQuizQuestions,
        onGetQuizYears,
      }}/>}
      {page === "study-overview" && <CourseStudyIntro {...{
        course: course || initCourse, modules, userCourse,
        onMoveToCourseStudy, 
        onBackToOverview() {
          setPage("full-view")
        },
        onBack,
      }}/>}
    </>
  )

};
